import React, {Component} from 'react';
import { Modal, Glyphicon } from 'react-bootstrap';
import './App.css';
import './index.css';
import ControlledCarousel from './Carousel.js';
import BathroomRating from './BathroomRating.js';

export default class LocationModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tipsDiv: "mTipsLarge",
            jsonData: require('./json/' + this.props.loc + '.json'),
        }

        this.getIcons = this.getIcons.bind(this);
    }

    // Determines the icons that need to be on the category list depending on category object in json
    getIcons() {
        let catDict = this.state.jsonData.categories;
        let iconList = [];

        if ('academics' in catDict) {
            iconList.push('bluestar.png');

            if ('library' in catDict)
            iconList.push('library.png');
            if ('universitybuilding' in catDict)
            iconList.push('school.png');

        }
        else if ('misc' in catDict) {
            iconList.push('redstar.png');

            if ('athleticfacility' in catDict)
            iconList.push('football-field.png');
            if ('dorm' in catDict)
            iconList.push('dorm.png');
            if ('clothingstore' in catDict)
            iconList.push('shirt.png');

        }
        else if ('recarea' in catDict) {
            iconList.push('orangestar.png');

            if ('pickupsports' in catDict)
            iconList.push('basketball.png');
            if ('fitnesscenter' in catDict)
            iconList.push('dumbbell.png');
            if ('yogaspot' in catDict)
            iconList.push('yogaspot.png');
            if ('sunbathingspot' in catDict)
            iconList.push('sunbed.png');
        }
        else if ('fooddrink' in catDict) {
            iconList.push('greenstar.png');

            if ('dessert' in catDict)
            iconList.push('ice-cream.png');
            if ('coffeeshop' in catDict)
            iconList.push('coffeeshop.png');
            if ('restaurant' in catDict)
            iconList.push('restaurant.png');
        }
        else if ('entertainment' in catDict) {
            iconList.push('yellowstar.png');

            if ('nightlife' in catDict)
            iconList.push('wine.png');
            if ('movietheater' in catDict)
            iconList.push('movietheater.png');
            if ('livemusic' in catDict)
            iconList.push('music-player.png');
        }
        if ('datespot' in catDict) {
            iconList.push('like.png');
        }
        if ('bestofaa' in catDict) {
            iconList.push('trophy.png');
        }
        if ('studyspot' in catDict) {
            iconList.push('studying.png')
        }
        return iconList;
    }

    /* Before component is mounted, let's figure out if we should make the tips div mTips or mTipsLarge
    This is simply determined by if there is a bathroomrating key in the json */
    componentWillMount() {
        if (this.state.jsonData.bathroomrating) {
            this.setState({
                tipsDiv: "mTips",
            });
        }
    }

    render() {
        let iconList = this.getIcons();

        return (
            <Modal className="locModal" show={this.props.showModal} onHide={this.props.close}>
                <div className="mTitle">{this.state.jsonData.name + "   "}

                    {/* This span with class of desktopIcons is only shown if width is a certain size. Check css for exact specifications */}
                    <span className="desktopIcons">
                        {
                            iconList &&
                            iconList.map(function (icon, index) {
                                let iconString = icon.split(".")[0]
                                return (
                                    <img src={icon} alt={iconString} style={{height: "25px", width: "25px", marginLeft: "12px"}} key={index} />
                                );
                            })
                        }
                    </span>

                    <Glyphicon glyph="remove" className="closeLocModal" onClick={this.props.close} />
                </div>
                <div className="mAddress"><a href={'http://www.google.com/search?q=' + this.state.jsonData.address}>{this.state.jsonData.address}</a></div>

                {/* This span with class of smallScreenIcons is only shown if width is a certain size. Check css for exact specifications */}
                <div className="smallScreenIcons"><strong>Categories:</strong>
                {
                    iconList &&
                    iconList.map(function (icon, index) {
                        let iconString = icon.split(".")[0]
                        return (
                            <img src={icon} alt={iconString} style={{height: "25px", width: "25px", marginLeft: "6px"}} key={index} />
                        );
                    })
                }
            </div>

            <ControlledCarousel images={this.state.jsonData.images} videos={this.state.jsonData.videos} />
            <div className="locBlock1">

                {
                    this.state.jsonData.tips  && (

                        <div className={this.state.tipsDiv}>
                            <div className="locModalHeader">
                                Tips & Tricks
                            </div>
                            <div className="locModalContent">
                                <ol>

                                    {this.state.jsonData.tips && this.state.jsonData.tips.map(function (tip, index) {
                                        return (
                                            <li key={index}><q>{tip.text}</q></li>
                                        );
                                    })}
                                </ol>
                                <a className="articleLink" href={'mailto:webteam@michigandaily.com?subject=' + this.props.loc}><em>Have a tip for {this.state.jsonData.name}? Submit it here for review!</em></a>
                            </div>
                        </div>


                    )}

                    {
                        this.state.jsonData.bathroomrating && (
                            <div className="mBathRatings">
                                <div className="locModalHeader">
                                    Bathroom Ratings
                                </div>
                                <div className="locModalContent">
                                    {
                                        this.state.jsonData.bathroomrating &&
                                        this.state.jsonData.bathroomrating.map(function (bathroom, index) {
                                            return (
                                                <div key={index}>
                                                    <BathroomRating bathroom={bathroom.bathroom} rating={bathroom.rating} />
                                                </div>
                                            );
                                        })
                                    }
                                    <a className="articleLink" href={'mailto:webteam@michigandaily.com?subject=' + this.props.loc}><em>Have a bathroom rating for {this.state.jsonData.name}? Submit it here for review!</em></a>
                                </div>
                            </div>
                        )}

                    {this.state.jsonData.foodRecommendations && (
                        <div className="mFoodRecommendations">
                            <div className="locModalHeader">
                                Recommendations
                            </div>
                            <div className="locModalContent">
                                <ol>
                                    {this.state.jsonData.foodRecommendations && this.state.jsonData.foodRecommendations.map(function (tip, index) {
                                        return (
                                            <li key={index}><q>{tip.text}</q></li>
                                        );
                                    })}
                                </ol>
                                <a className="articleLink" href={'mailto:webteam@michigandaily.com?subject=' + this.props.loc}><em>Have a recommendation for {this.state.jsonData.name}? Submit it here for review!</em></a>
                            </div>
                        </div>
                    )}
                </div>
                <div className="locBlock2">
                    <div className="mArticle1">
                        <div className="locModalHeader">Related Articles</div>
                        <h5 className="articleTitle">{this.state.jsonData.articleTitle1}</h5>
                        <p className="articleContent">{this.state.jsonData.articleSnippet1}</p>
                        <a className="articleLink" href={this.state.jsonData.articleLink1}>Read More</a>
                    </div>
                    <div className="mArticle2">
                        <div className="locModalHeader">Related Articles</div>
                        <h5 className="articleTitle">{this.state.jsonData.articleTitle2}</h5>
                        <p className="articleContent">{this.state.jsonData.articleSnippet2}</p>
                        <a className="articleLink" href={this.state.jsonData.articleLink2}>Read More</a>
                    </div>
                </div>

            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/LocationModal.js